export class UpcCorrectionSetting {
    static trimOptions: Array<number> = Array.from(Array(10).keys());
    calculateCheckDigit = false;
    totalCharactersToTrim = 0;

    constructor(options?: Partial<UpcCorrectionSetting>) {
        Object.assign(this, options);
    }
}
